import { TreeNode } from 'react-organizational-chart'

import { flattenArray } from 'src/utils'

import { ListProps } from '../types'

import { GroupNode } from './GroupNode'
import { SubList } from './SubList'

export const List = ({ data, depth, idx, onAddChild }: ListProps) => {
  const hasChild = data?.children && !!data?.children

  return (
    <TreeNode
      label={
        <GroupNode
          idx={idx}
          node={data}
          depth={depth}
          onAddChild={onAddChild}
          length={flattenArray(data?.children ?? [], 'children')?.length}
        />
      }
    >
      {hasChild && (
        <SubList
          data={data.children ?? []}
          depth={depth}
          idx={idx}
          onAddChild={onAddChild}
        />
      )}
    </TreeNode>
  )
}
